module.exports = __webpack_public_path__ + "img/200.76bf45c.png";